module.exports = __webpack_public_path__ + "img/logo.6a5a6ad7.png";